module.exports = __webpack_public_path__ + "static/media/spot4.801b6145.png";